import { IPlaceScope } from '../../app/IPlaceScope';
import {
  ISubplaceCountsScope,
  ISubplaceTabsScope,
  SubplaceCountsHelper,
  SubplaceTabsHelper,
} from '../helpers/SubplaceCountsHelper';
import { IPlace } from '../models/IPlace';
import { Module } from '../Module';
import { ServerService } from '../services/ServerService';

export interface ITasksScope extends IPlaceScope, ISubplaceCountsScope, ISubplaceTabsScope {
  siteOrServer: 'site' | 'server';
  dataAlertsEnabled: boolean;
  showFlowsTab: boolean;
}

export class TasksCtrl {

  public static $inject = [
    '$scope',
    '$state',
    'ServerService',
    'place',
    'siteId'
  ];

  constructor(
      $scope: ITasksScope,
      $state: ng.ui.IStateService,
      ServerService: ServerService,
      place: IPlace,
      siteId?: string) {
    $scope.siteOrServer = siteId ? 'site' : 'server';
    $scope.dataAlertsEnabled = ServerService.isDataAlertsEnabled();
    $scope.showFlowsTab = (ServerService.flowsOnSiteEnabled() && $scope.siteOrServer === 'site') || (ServerService.flowsOnServerEnabled() && $scope.siteOrServer === 'server');

    SubplaceTabsHelper.refreshWhenCurrentTabClicked($scope, $state);
    SubplaceCountsHelper.keepSubplaceCountsUpdated($scope, place);
  }

}

Module.instance().controller('TasksCtrl', TasksCtrl);
